import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import HomePage from "@/pages/HomePage";
import OfferPage from "@/pages/OfferPage";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ofertaultimotrimestre" element={<OfferPage />} />
        </Routes>
        <FloatingWhatsApp />
        <Toaster position="top-center" richColors />
      </HashRouter>
    </div>
  );
}

export default App;
